import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Form, InputGroup  } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import EditContraModal from './EditContraModal';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FinPaymentVoucher = () => {
  const [isEditable, setIsEditable] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);
  
  // Header data
  const [headerData, setHeaderData] = useState({
    fin_year1: "",
    trans_type: "CV",
    vchr_no: "",
    vchr_date: new Date().toISOString().split("T")[0],
    dr_cb_code: "",
    dr_amt: "",
    dr_narration: "",
    cr_cb_code: "",
    cr_amt: "",
    cr_narration: "",
    bank_date: "",
    sect_id: "",
    // cc_id: "",
    // bgt_id: "",
  });

  // Dropdown data
  const [dropdowns, setDropdowns] = useState({
    commonList: [],
    cbCodes: [],
  });

  const [ddlSections, setDdlSections] = useState([]);

  const [showsearchModal, setShowSearchModal] = useState(false);

  // Fetch dropdown lists
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [CashBankRes, SectionRes] =
          await Promise.all([
            axios.get(`${BASE_URL}/api/ddl_CashBank_Mast`),
            //axios.get(`${BASE_URL}/api/ddl_common_master`),
            axios.get(`${BASE_URL}/api/ddl_sections`),
          ]);

        setDropdowns({
          cbCodes: CashBankRes.data,
          //commonList: CommonRes.data,
        });

        setDdlSections(SectionRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdowns();
  }, []);

  // 🔹 Format helper (remove commas etc.)
  // const parseNumber = (val) => {
  //   if (!val) return 0;
  //   return parseFloat(val.toString().replace(/,/g, "")) || 0;
  // };

  // Handle input change for header
  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setHeaderData((prev) => ({ ...prev, [name]: value }));

  };

  const handleHdrAmtChange = (e) => {

    let {name ,value} = e.target;

    // Remove commas before validating
    value = value.replace(/,/g, "");

    // Allow only digits and at most one decimal point
    if (!/^\d*\.?\d*$/.test(value)) {
      return; // Ignore invalid input
    }

    if (name === 'cr_amt')  
      setHeaderData((prev) => ({ ...prev, 'cr_amt': value }));
    else setHeaderData((prev) => ({ ...prev, 'dr_amt': value }));


    // if (!headerData.dr_amt) {
    //   setHeaderData((prev) => ({ ...prev, 'cr_amt': value }));
    // }

  };

  const handleBlur = (e) => {

    const {name, value} = e.target;

    //if (headerData.cr_amt === "") return;
    if (value === "") return;

    // ✅ Convert to number and truncate instead of round
    //let numericValue = parseFloat(headerData.hdr_amt);
    let numericValue = parseFloat(value.replace(/,/g, ""));
    if (isNaN(numericValue)) return;

    // Truncate to two decimals (no rounding)
    numericValue = Math.trunc(numericValue * 100) / 100;

    const formatted = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(numericValue));

    //setAmount(formatted);
    if (name === 'cr_amt') 
      setHeaderData((prev) => ({ ...prev, 'cr_amt': formatted }));
    else 
      setHeaderData((prev) => ({ ...prev, 'dr_amt': formatted }));

    if (name === 'cr_amt')
      setHeaderData((prev) => ({ ...prev, 'dr_amt': formatted }));
    else if (name === 'dr_amt')
      setHeaderData((prev) => ({ ...prev, 'cr_amt': formatted }));

  };

  // Handle button actions
  const handleNew = () => {
    resetPage();
    setIsEditable(true);
    setIsEditMode(false);
  };

  const resetPage = () => {
    
    setHeaderData({
    fin_year1: "",
    trans_type: "CV",
    vchr_no: "",
    vchr_date: new Date().toISOString().split("T")[0],
    dr_cb_code: "",
    dr_amt: "",
    dr_narration: "",
    cr_cb_code: "",
    cr_amt: "",
    cr_narration: "",
    bank_date: "",
    sect_id: "",
    // cc_id: "",
    // bgt_id: "",
    });

    setIsEditMode(true);

  }

  const handleClear = () => {
    if (window.confirm("Sure you want to clear all data ?")) {
      resetPage();
      setIsEditable(false);
    }
  };

  // const handleEdit = () => {
  //   setIsEditable(true);
  // };

  const handleSave = async () => {

    if (!headerData.vchr_date || headerData.vchr_date === '') {
      toast.error('Please enter Voucher Date.');
      return;
    }

    if (!headerData.sect_id || headerData.sect_id === '') {
      toast.error('Please select Section.');
      return;
    }

    if (!headerData.cr_cb_code || headerData.cr_cb_code === '') {
      toast.error('Please select Transfer From Cash/Bank Account.');
      return;
    }

    if (!headerData.cr_amt || headerData.cr_amt === 0) {
      toast.error('Please select Transfer From Amount (Cr).');
      return;
    }

    if (!headerData.cr_narration || headerData.cr_narration === 0) {
      toast.error('Please select Transfer From Narration (Cr).');
      return;
    }

    if (!headerData.dr_cb_code || headerData.dr_cb_code === '') {
      toast.error('Please select Transfer To Cash/Bank Account.');
      return;
    }

    if (!headerData.dr_amt || headerData.dr_amt === 0) {
      toast.error('Please select Transfer To Amount (Dr).');
      return;
    }

    if (!headerData.dr_narration || headerData.dr_narration === 0) {
      toast.error('Please select Transfer To Narration (Dr).');
      return;
    }

    if (headerData.dr_amt !== headerData.cr_amt) {
      toast.error('Debit and Credit Amounts are not tallying.');
      return;
    }

    const response = await axios.get(`${BASE_URL}/api/validate_vchr_date`, { 
      params: { p_VchrDate: headerData.vchr_date, p_Sect_Id: headerData.sect_id }, });

    if (response.data[0].fin_status === 'CLOSED' || response.data[0].fin_status === 'FISCAL') {
      toast.error('Voucher cannot be made in Closed or Fiscal year. Please check the Voucher Date.');
      return;
    }

    const isConfirmed = window.confirm("Sure you want to save this record?");
    if (!isConfirmed) return;

    const payload = {
      header: headerData,
//      details: detailRows,
    };

    try {
      const response = await axios.post(`${BASE_URL}/api/save_ContraVoucher`, payload);
      if (response.data.message !== '0') {
        toast.success(`Vocuher No ` + response.data.message + ` saved successfully`);
        setIsEditable(false);
        resetPage();
      }
    } catch (err) {
      console.error("Save error:", err);
      toast.error("Failed to save Voucher. Please check input!");
    }
  };

  const handleVchrRowSelect = async (selRow) => {

    setShowSearchModal(false);

    const response = await axios.get(`${BASE_URL}/api/get_Vchr_ById`, {
            params: {p_Sect_Id: selRow.sect_id, p_FinYear1: selRow.fin_year1, p_VchrNo: selRow.vchr_no, p_TransType: 'CV'},
          });

    headerData.vchr_no = selRow.vchr_no;
    headerData.trans_type = 'CV';
    headerData.fin_year1 = selRow.fin_year1;
    headerData.vchr_date = response.data[0].vchr_date;
    headerData.cr_cb_code = response.data[0].cb_code;
    headerData.cr_amt = response.data[0].amount;
    headerData.cr_narration = response.data[0].narration;
    headerData.sect_id = response.data[0].sect_id;
    // headerData.cc_id = response.data[0].cc_id;
    // headerData.bgt_id = response.data[0].bgt_id;
    headerData.dr_cb_code = response.data[1].cb_code;
    headerData.dr_amt = response.data[1].amount;
    headerData.dr_narration = response.data[1].narration;

    // handleBlur();

    setIsEditable(true);
    setIsEditMode(true);

  };

  return (
    <Container fluid className="p-3">
      {/* Header */}
      <Card className="p-3 mb-4">
        <Row className="mb-3">
          <Col md={3}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text>Voucher No</InputGroup.Text>
              <Form.Control style={{ textAlign: 'right' }} type="text" name="vchr_no"
                className="form-control" value={headerData.vchr_no} disabled />
            </InputGroup>
          </Col>
          <Col md={3}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text>Voucher Date</InputGroup.Text>
              <Form.Control type="date" name="vchr_date" className="form-control"
                value={headerData.vchr_date} onChange={handleHeaderChange} disabled={!isEditable} />
            </InputGroup>
          </Col>
           <Col md={2}></Col>
          <Col md={4}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text>Section</InputGroup.Text>
            <Form.Select
              className="form-select"
              name="sect_id"
              value={headerData.sect_id}
              onChange={handleHeaderChange}
              disabled={isEditMode}
            >
              <option value="">-- Select Section --</option>
              {ddlSections.map(sec => (
                <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
              ))}
            </Form.Select>
            </InputGroup>
          </Col>

        </Row>

        <h5 className="mb-1 text-start text-primary">Transfer From Cash/Bank (Cr)</h5>
        {/* <hr style={{
          width: '250px',          // short line
          margin: '0px auto',    // center horizontally
          border: '1px solid #000' // line color and thickness
        }} /> */}

        <Row className="mb-1">
          <Col md={6}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text style={{ width: "120px" }}>Transfer From</InputGroup.Text>
              <Form.Select className="form-select" name="cr_cb_code" value={headerData.cr_cb_code}
                onChange={handleHeaderChange} disabled={!isEditable} >
                <option value="">-- Select From Cash/Bank --</option>
                {dropdowns.cbCodes.map((cb) => (
                  <option key={cb.cb_code} value={cb.cb_code}>
                    {cb.cb_name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>

          <Col md={4} className="text-end">
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text style={{ width: "100px" }}>Amount</InputGroup.Text>
              <Form.Control
                type="text" name="cr_amt" className="form-control text-end"
                value={headerData.cr_amt} onChange={handleHdrAmtChange} onBlur={handleBlur}
                disabled={!isEditable} />
              {/* <InputGroup.Text style={{ width: "40px" }}>Cr</InputGroup.Text> */}
              {/* , background: 'orange' */}
            </InputGroup>
          </Col>

          <Col md={4} className="text-end">
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text style={{ width: "100px" }}>Amount</InputGroup.Text>

              {/* <Form.Control className="form-select" name="bankdrcr" value={headerData.bankdrcr}
                onChange={handleHdrAmtChange} disabled={!isEditable} >
                <option value="DR">Dr</option>
                <option value="CR">Cr</option>
              </Form.Control> */}
            </InputGroup>
          </Col>

        </Row>

        <Row className="mb-3">
          <Col md={8}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text style={{ width: "120px" }}>Narration Cr</InputGroup.Text>
              <Form.Control
                type="text"
                name="cr_narration"
                className="form-control"
                value={headerData.cr_narration}
                onChange={handleHeaderChange}
                disabled={!isEditable} />
            </InputGroup>
          </Col>
        </Row>

        <h5 className="mb-1 text-start text-primary">Transfer To Cash/Bank (Dr)</h5>
        {/* <hr style={{
          width: '250px',          // short line
          margin: '0px auto',    // center horizontally
          border: '1px solid #000' // line color and thickness
        }} /> */}

        <Row className="mb-1">
          <Col md={8}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text style={{ width: "120px" }}>Transfer To</InputGroup.Text>
              <Form.Select className="form-select" name="dr_cb_code" value={headerData.dr_cb_code}
                onChange={handleHeaderChange} disabled={!isEditable} >
                <option value="">-- Select To Cash/Bank --</option>
                {dropdowns.cbCodes.map((cb) => (
                  <option key={cb.cb_code} value={cb.cb_code}>
                    {cb.cb_name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>

          <Col md={4} className="text-end">
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text style={{ width: "100px" }}>Amount</InputGroup.Text>
              <Form.Control
                type="text" name="dr_amt" className="form-control text-end"
                value={headerData.dr_amt} onChange={handleHdrAmtChange} onBlur={handleBlur}
                disabled={!isEditable} />
              <InputGroup.Text style={{ width: "40px" }}>Dr</InputGroup.Text>
              {/* , background: 'orange' */}
            </InputGroup>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={8}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text style={{ width: "120px" }}>Narration Dr</InputGroup.Text>
              <Form.Control
                type="text"
                name="dr_narration"
                className="form-control"
                value={headerData.dr_narration}
                onChange={handleHeaderChange}
                disabled={!isEditable} />
            </InputGroup>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={12} className="d-flex justify-content-end">
            <Button style={{height: '40px', marginTop: '10px', width: '100px'}} className="me-2" variant="primary" 
                  disabled={isEditable} onClick={handleNew}>New </Button>
            <Button style={{height: '40px', marginTop: '10px', width: '100px'}} className="me-2" variant="warning"
                   disabled={isEditable} onClick={(e) => (setShowSearchModal(true))}>Edit </Button>
            {showsearchModal && (
              <EditContraModal
                show={showsearchModal}
                handleClose={() => setShowSearchModal(false)}
                onRowSelect={handleVchrRowSelect}
              />
            )}
            <Button style={{height: '40px', marginTop: '10px', width: '100px'}} className="me-2" variant="secondary" 
                           disabled={!isEditable} onClick={handleClear}>Clear</Button>
            <Button style={{height: '40px', marginTop: '10px', width: '100px'}} className="me-2" variant="success" 
                        disabled={!isEditable} onClick={handleSave}>Save</Button>
          </Col>
        </Row>
        {/* <div className="d-flex justify-content-between align-items-center mb-3" style={{marginTop: '10px'}}>
          <div className="d-flex gap-2">
            <InputGroup style={{ width: "300px" }}>
              <InputGroup.Text style={{ width: "110px", background: "lightblue", color: "black" }}>Total Dr Amt</InputGroup.Text>
              <input type="text" name="totDrAmt" className="form-control text-end"
                value={totDrAmt} disabled min="0" />
            </InputGroup>
            <InputGroup style={{ width: "300px" }}>
              <InputGroup.Text style={{ width: "110px", background: "lightblue", color: "black" }}>Total Cr Amt</InputGroup.Text>
              <Form.Control type="text" name="totCrAmt" className="form-control text-end"
                value={totCrAmt} disabled min="0" />
            </InputGroup>
            <InputGroup style={{ width: "300px" }}>
              <InputGroup.Text style={{ width: "110px", background: "orange", color: "black" }}>Difference</InputGroup.Text>
              <Form.Control type="text" name="totAmtDiff" className="form-control text-end"
                value={totAmtDiff} disabled min="0" />
            </InputGroup>
          </div>
        </div> */}

      </Card>

    </Container>
  );
};

export default FinPaymentVoucher;
